import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import React from 'react';
import Content from 'Views/Page/Content/Templates/WizardTemplates/WizardBigHierarchyMultipicklistControl/Content';
import WhatIfStepNavigator from 'Views/Page/Content/Modal/Components/WhatIfStepNavigator';
import classNames from 'classnames';
import useMobileLayout from 'Hooks/useMobileLayout';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

const styles = (theme) => ({
  root: {
    width: '100%',
  },
  navigator: {
    maxWidth: theme.dimensions.md,
  },
});

const Layout = ({
  className,
  classes,
}) => {
  const isMobile = useMobileLayout();
  const { loadModalCollectionByLink } = useModalContext();
  const {
    resource,
    saving,
    onSubmit,
  } = useMetaLayoutContext();
  const previousLink = resource.relationship(fr.relationships.previousLink.name)?.link('related');

  return (
    <Box
      className={classNames(classes.root, className)}
    >

      <div className={classNames(classes.content, {
        [classes.contentDesktop]: !isMobile,
      })}
      >
        <Content />
      </div>
      <WhatIfStepNavigator
        className={classes.navigator}
        isLoading={saving}
        onNext={() => {
          onSubmit();
        }}
        onPrevious={(previousLink) ? async () => {
          await loadModalCollectionByLink(previousLink.url());
        } : null}
      >
        {resource.attr('primaryActionLabel') || null}
      </WhatIfStepNavigator>
    </Box>
  );
};
Layout.defaultProps = {
  className: '',
};

Layout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};


export default withStyles(styles)(Layout);
